// extracted by mini-css-extract-plugin
export default {"root":"TeachAnalyse_root__krpAh"};